<template>
    <div>
        <icon-circled
            v-if="icon"
            :size="110"
            :icon="icon"
            :class="$css($theme.textPrimary)"
            class="d-block mx-auto mb-4"
        />

        <p
            v-if="title"
            class="font--20 lh--26 font-weight-light text-center mb-8"
            :class="$css($theme.textPrimary)"
        >
            {{ ucfirst(title) }}
        </p>

        <p
            v-if="description"
            class="font--14 text-dark text-center mb-0 text--ucfirst"
            v-html="description"
        />

        <div class="d-flex justify-content-between text-center mt-24">
            <base-button
                class="mlsp-16 mnw-50 mxw-80 mx-auto"
                data-t="button-confirm"
                @click="accept"
            >
                {{ confirmText }}
            </base-button>
        </div>
    </div>
</template>

<script>
import { ucfirst } from "~/lib/utils"
import BaseButton from "~/components/buttons/BaseButton"
import IconCircled from "~/components/elements/IconCircled"

export default {
    props: {
        title: String,
        description: String,
        icon: {
            type: String,
            default: "info",
        },

        options: {
            type: Object,
            default: () => {
                return {}
            },

            required: false,
        },
    },

    emits: ["done"],

    computed: {
        confirmText() {
            if (this.options.confirmText) {
                return this.options.confirmText
            }
            return this.$t("common.accept")
        },
    },

    methods: {
        accept() {
            this.$emit("done", true)
        },

        ucfirst,
    },

    components: {
        BaseButton,
        IconCircled,
    },
}
</script>
